import { render, staticRenderFns } from "./tags-manage.vue?vue&type=template&id=35253532"
import script from "./tags-manage.vue?vue&type=script&lang=ts"
export * from "./tags-manage.vue?vue&type=script&lang=ts"
import style0 from "./tags-manage.vue?vue&type=style&index=0&id=35253532&prod&module=true&lang=stylus"
import style1 from "./tags-manage.vue?vue&type=style&index=1&id=35253532&prod&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports